import React, { createContext, PropsWithChildren, useReducer } from 'react';
import { ISurveyResultsFilter } from 'models';

export interface ISurveyResultsFilterContext {
	surveyFilter: ISurveyResultsFilter;
	onChangeSurveyResultsFilter: (d: ISurveyResultsFilter) => void;
}

export const SurveyResultsFilterContext = createContext<
	ISurveyResultsFilterContext
>({
	surveyFilter: {},
	onChangeSurveyResultsFilter: () => {},
});

export const SurveyResultsFilterContextProvider = ({
	children,
}: PropsWithChildren<{}>) => {
	const [surveyResultsFilter, onChangeSurveyResultsFilter] = useReducer(
		(state: ISurveyResultsFilter, payload: ISurveyResultsFilter) => ({
			...state,
			...payload,
		}),
		{},
	);

	return (
		<SurveyResultsFilterContext.Provider
			value={{
				surveyFilter: surveyResultsFilter,
				onChangeSurveyResultsFilter,
			}}
		>
			{children}
		</SurveyResultsFilterContext.Provider>
	);
};
